<template>
  <div class="bottombody">
    <el-divider content-position="left">许可证分类管理</el-divider>
    <div style="display: flex">
      <el-select
        v-model="searchArr.id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入分类名称"
        size="mini"
        clearable
        :remote-method="searchRemoteLicence"
        :loading="searchLoading"
        @change="handleSearchLicence"
      >
        <el-option
          v-for="searchLicenceItem in searchLicences"
          :key="searchLicenceItem.id"
          :label="searchLicenceItem.name"
          :value="searchLicenceItem.id"
        >
        </el-option>
      </el-select>
      <div style="text-align: right; flex: 1">
        <el-button type="primary" size="mini" @click="handleLicenceAdd">录入</el-button>
      </div>
    </div>
    <el-drawer
      title="录入"
      :visible.sync="handleLicenceAdddrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="licenceForm"
          :rules="rules"
          ref="licenceForm"
          label-width="100px"
        >
          <el-form-item label="名称" prop="nav">
            <el-input v-model="licenceForm.nav" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="分类" prop="pid">
            <div style="display: flex; flex-direction: row">
              <div style="margin-right: 0.2rem; width: 100%">
                <el-cascader
                  clearable
                  filterable
                  v-model="licenceForm.pid"
                  :options="options"
                  :props="{
                    expandTrigger: 'hover',
                    label: 'name',
                    value: 'id',
                    checkStrictly: true,
                  }"
                  @click.native="loadLicenceCate"
                  size="mini"
                  style="width: 100%"
                  ref="cascader"
                ></el-cascader>
              </div>
              <div>
                <el-popover
                  placement="bottom"
                  width="500"
                  trigger="click"
                  @hide="clearSelf"
                >
                  <el-form
                    :model="addCateForm"
                    :rules="rules"
                    ref="addCateForm"
                    label-width="80px"
                  >
                    <el-form-item label="分类名称" prop="name">
                      <el-input
                        v-model="addCateForm.name"
                        size="mini"
                        placeholder="请输入分类名称"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="排序" prop="sort">
                      <el-input
                        v-model="addCateForm.sort"
                        size="mini"
                        type="number"
                        min="1"
                        placeholder="排序值"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="是否显示" prop="display">
                      <el-radio-group v-model="addCateForm.display" size="mini">
                        <el-radio-button label="1">是</el-radio-button>
                        <el-radio-button label="0">否</el-radio-button>
                      </el-radio-group>
                    </el-form-item>
                  </el-form>
                  <div style="margin-top: 0.15rem; text-align: right">
                    <el-button
                      type="primary"
                      size="mini"
                      @click="saveChange('addCateForm')"
                      >保存</el-button
                    >
                  </div>
                  <el-button type="primary" size="mini" slot="reference"
                    >新增分类
                  </el-button>
                </el-popover>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input
              v-model="licenceForm.sort"
              size="mini"
              type="number"
              min="1"
              placeholder="排序值"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否显示" prop="display">
            <el-radio-group v-model="licenceForm.display" size="mini">
              <el-radio-button label="1">是</el-radio-button>
              <el-radio-button label="0">否</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <div style="text-align: right">
            <el-button type="primary" size="mini" @click="submitForm('licenceForm')"
              >保存</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="修改"
      :visible.sync="editCateFormDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="editlicenceForm"
          :rules="rules"
          ref="editlicenceForm"
          label-width="100px"
        >
          <el-form-item label="分类名称" prop="name">
            <el-input v-model="editlicenceForm.name" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input
              v-model="editlicenceForm.sort"
              size="mini"
              type="number"
              min="1"
              placeholder="排序值"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否显示" prop="display">
            <el-radio-group v-model="editlicenceForm.display" size="mini">
              <el-radio-button label="1">是</el-radio-button>
              <el-radio-button label="0">否</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editSubmitForm('editlicenceForm')"
              >修改</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-table
      ref="licenceData"
      max-height="650"
      :data="licenceData"
      style="width: 100%; margin-top: 10px"
      row-key="id"
      @expand-change="change"
      lazy 
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
    >
      <el-table-column prop="name" label="名称"> </el-table-column>
      <el-table-column prop="display" label="是否显示">
        <template slot-scope="scope">
            <el-switch
            style="display: block"
            v-model="ListIfDisplay[scope.row.id]"
            active-color="#ff4949"
            inactive-color="#13ce66"
            active-text="隐藏"
            inactive-text="显示"
            @click.native="editListRadioC(scope.row)"
            > 
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            v-model="listSort[scope.row.id]"
            @blur="setSortC(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button
              @click.native.prevent="editRow(scope.$index, scope.row)"
              type="primary"
              size="mini"
              icon="el-icon-edit"
              circle
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "LicenceManage",
  data() {
    var pid = (rule, value, callback) => {
      if (value.length > 100) {
        return callback(new Error("输入过长！"));
      }
      if (value.length === 0) {
        return callback(new Error("请输入名称！"));
      }
      callback();
    };
    return {
      direction: "rtl",
      addCateForm: {
        name: "",
        display: "1",
        sort: 0,
      },
      searchArr: {
        id: "",
      },
      loadC: [],
      licenceData: [],
      searcher: null,
      editCateFormDrawer: false,
      searchLoading: false,
      searchLicences: [],
      handleLicenceAdddrawer: false,
      ListIfDisplay: [],
      listSort: [],
      options: [],
      licenceForm: {
        nav: "",
        pid: "",
        name: "",
        sort: 0,
        display: "1",
      },
      editlicenceForm: {
        id: "",
        name: "",
        sort: 0,
        display: "1",
      },
      rules: {
        pid: [
          {
            validator: pid,
            trigger: "blur",
          },
          { required: true, message: "请输入分类", trigger: "blur" },
        ],
        nav: [{ required: true, message: "请输入名称", trigger: "blur" }],
        name: [
          { required: true, message: "请输入分类名称", trigger: "blur" },
          { max: 100, message: "分类名不超过100字符", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.loadTable();
  },
  computed: {
    collapse() {
      return this.$store.state.collapse;
    },
  },
  watch: {
    "licenceForm.pid": {
      handler() {
        if (this.$refs.cascader) {
          this.$refs.cascader.dropDownVisible = false;
        }
      },
    },
  },
  methods: {
    // 列表
    loadTable() {
      this.$axios
        .get("api/admin/mini_pro/licence/list", {
          params: {
            searchItem: this.searcher,
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.licenceData = data.data;
            this.loadSort();
            this.loadRadio();
          }
        })
        .catch();
    },
    loadRadio () {
      if (!this.licenceData) return false
      this.licenceData.map(item => {
        if (item.display === 1) {
          this.ListIfDisplay[item.id] = false
        } else {
          this.ListIfDisplay[item.id] = true
        }
      })
    },
    loadSort() {
      if (!this.licenceData) return;
      this.licenceData.map((item) => {
        this.listSort[item.id] = Number(item.sort);
      });
    },
    // 编辑
    editRow(index, row) {
      this.editlicenceForm.id = row.id;
      this.editlicenceForm.name = row.name;
      this.editlicenceForm.sort = row.sort;
      this.editlicenceForm.display = row.display;
      this.editCateFormDrawer = true;
    },
    searchRemoteLicence(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchItem(query);
        }, 200);
      } else {
        this.searchLicences = [];
      }
    },
    searchItem(query) {
      this.$axios
        .get("api/admin/mini_pro/licence/get_item", {
          params: {
            search: query,
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchLicences = data.data;
          }
        })
        .catch();
    },
    handleSearchLicence(query) {
      this.searcher = query;
      setTimeout(() => {
        this.loadTable();
      });
    },
    handleLicenceAdd() {
      this.handleLicenceAdddrawer = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post("api/admin/mini_pro/licence/store", {
              name: this.licenceForm.nav,
              parents: this.licenceForm.pid,
              display: this.licenceForm.display,
              sort: this.licenceForm.sort,
            })
            .then((res) => {
              const { data } = res;
              if (data.code === 1) {
                this.$message.success(data.msg);
                this.handleLicenceAdddrawer = false;
                this.resetForm("licenceForm");
                this.loadTable();
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editSubmitForm(formName) {
      setTimeout(() => {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$axios
              .put("api/admin/mini_pro/licence/save", {
                id: this.editlicenceForm.id,
                name: this.editlicenceForm.name,
                display: this.editlicenceForm.display,
                sort: this.editlicenceForm.sort
              })
              .then((res) => {
                const { data } = res;
                if (data.code === 1) {
                  this.$message.success(data.msg);
                  this.editCateFormDrawer = false;
                  this.loadTable();
                  this.toggleRowExpansion_forAll(this.licenceData, false);
                } else {
                  this.$message.error(data.msg);
                }
              })
              .catch();
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      });
    },
    editListRadioC(row) {
      setTimeout(() => {
        this.$axios
          .put("api/admin/mini_pro/licence/list_show", {
            id: row.id,
            display: this.ListIfDisplay[row.id] === false ? 1 : 0,
          })
          .then((res) => {
            const { data } = res;
            if (data.code === 1) {
              this.$message.success(data.msg);
              this.loadTable();
            } else {
              this.$message.error(data.msg);
            }
          })
          .catch();
      });
    },
    setSortC(row) {
      setTimeout(() => {
        if (isNaN(this.listSort[row.id])) {
          this.$message.error("排序值为数字！");
          return false;
        }
        this.$axios
          .put("api/admin/mini_pro/licence/set_sort", {
            id: row.id,
            sort: this.listSort[row.id],
          })
          .then((res) => {
            const { data } = res;
            if (data.code === 1) {
              this.$message.success(data.msg);
              this.loadTable();
            } else {
              this.$message.error(data.msg);
            }
          })
          .catch();
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    saveChange(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post("api/admin/mini_pro/licence/add_cate", this.addCateForm)
            .then(({ data }) => {
              if (data.code === 1) {
                var myEvent = new Event("click");
                document.dispatchEvent(myEvent);
                this.$message.success(data.msg);
                this.loadTable();
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        }
      });
    },
    clearSelf() {
      this.resetForm("addCateForm");
    },
    loadLicenceCate() {
      this.$axios
        .get("api/admin/mini_pro/licence/get_cate")
        .then(({ data }) => {
          if (data.code === 1) {
            this.options = data.data;
          }
        })
        .catch();
    },
    loadSortC(c) {
      c.map((item) => {
        this.listSort[item.id] = Number(item.sort);
      });
    },
    change(v1, v2) {
      if (v2) {
        this.loadC = v1.children;
        var cChildren = v1.children;
        this.loadSortC(cChildren);
      } else {
        this.loadC = [];
        this.cChildren = [];
      }
    },
    toggleRowExpansion_forAll(data, isExpansion) {
      data.forEach((item) => {
        this.$refs.licenceData.toggleRowExpansion(item, isExpansion);
        if (item.children !== undefined && item.children !== null) {
          this.toggleRowExpansion_forAll(item.children, isExpansion);
        }
      });
    },
  },
};
</script>

<style scoped>
.bottombody {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.el-switch {
    line-height: 23px;
    height: 23px;
}
</style>



// WEBPACK FOOTER //
// src/pages/setting_panel/LicenceManage.vue